<template>
  <div>

    <div class="flex flex-row">
      <h1 v-if="team">
        Team {{ team.name }}
      </h1>
      <pv-dropdown
        v-model="selectedYouth"
        :options="youths"
        option-value="value"
        option-label="key"
        placeholder="Jugend wählen"
        @change="setYouth"
      />
    </div>

    <div class="mt-10 flex flex-col">
      <div class="flex-row mb-4">
        <router-link :to="{ name: 'mail.write', params: { team: this.teamId} }">
          <pv-button class="ml-4">
            Team E-Mail schreiben
          </pv-button>
        </router-link>
      </div>
      <div class="flex-row ">
        Einladungen
        <pv-button
          class="ml-4"
          type="button"
          @click="getInviteCode()"
        >
          InviteCode erstellen
        </pv-button>
      </div>
      <div
        v-for="code in inviteCodes"
        :key="code"
        class="flex flex-row"
      >
        <div>
          <router-link :to="{name:'teams.invite',params:{id:teamId,code:code}}">
            {{ code }}
          </router-link>
        </div>
      </div>
    </div>

    <div
      v-if="team"
      class="mt-10 flex flex-row"
    >
      <div class="mr-4">
        <h2 class="mb-2 flex flex-row  primary-bg text-white p-2">
          <span class="flex-grow">Mitglieder - {{ team.members.length }}</span>
          <span
            class="text-xs text-white cursor-pointer"
            @click="clipAllMails"
          ><i class="fas fa-copy mr-2"/> Verteiler</span>

          <span
            class="text-xs text-white cursor-pointer"
            @click="clipAllMailsWithName"
          >
            <i class="fas fa-copy mr-2"/> Liste</span>
        </h2>

        <div
          v-for="member in team.members"
          :key="member.id"
          class="flex flex-row "
          @change="memberSelected(member.id)"
        >
          <input
            type="checkbox"
            class="mr-2"
          >

          <p class="mr-4 text-xs font-hairline w-8">
            {{ member.ageGroup }}
          </p>

          <router-link :to="{ name: 'player.profile', params: { id: member.id} }">
            <p class="w-48 font-medium flex-grow">
              {{ member.name }}
            </p>
          </router-link>

          <router-link :to="{name:'teamsAddToTUsers', params: { id: teamId,users:[member.id]}}">
            <span class="icon-stack  mr-2 cursor-pointer">
              <i class="fas fas fa-users"/>
              <i class="fas fa-plus"/>
            </span>
          </router-link>

          <router-link
            v-if="member.eMailAdresses && member.eMailAdresses.length>0"
            :to="{ name: 'mail.write', params: { recepients: [member]} }"
          >
            <i class="far fa-envelope mr-2 cursor-pointer"/>
          </router-link>

          <div class="mr-2 items-right justify-end w-8">
            <i
              v-if="member.eMailAdresses && member.eMailAdresses.length>0"
              class="fas fa-copy cursor-pointer"
              @click="clipMails(member.eMailAdresses)"
            />
            <i
              v-else
              class="w-64"
            />
          </div>
          <i
            class="fas fa-trash-alt"
            @click="removeMember(member.id)"
          />
        </div>

        <div
          v-if="selectedMembers && selectedMembers.length>0"
          class="member-multi-action-container"
        >
          {{ selectedMembers.length }} Mitglieder gewählt
          <router-link :to="{name:'teamsAddToTUsers', params: { id: teamId,users:selectedMembers}}">
            <span class="icon-stack  mr-2 cursor-pointer">
              <i class="fas fas fa-users"/>
              <i class="fas fa-plus"/>
            </span>
          </router-link>
        </div>

        <div>

          <router-link :to="{name:'teams.player.add',params:{id:teamId}}">
              <pv-button>
                Spieler Anlegen
              </pv-button>
            </router-link>
        </div>
      </div>
      <div>
        <h2 class="mb-2  flex flex-row primary-bg text-white p-2">
          <span class="flex-grow">Spiele</span>
          <router-link :to="{name:'team.matches.create'}">
            <h3><i class="fas fa-calendar-plus"/></h3>
          </router-link>
        </h2>
        <div class="mb-8">
          <div v-if="nextEvents">
            <div
              v-for="item in nextEvents.events"
              :key="item"
              class="flex flex-row"
            >
              <span class="mr-2">{{ item.time|formatDate }}</span> <span
              class="flex-grow font-bold"
            >{{ item.title }}</span><span>
                <router-link
                  class="cursor-pointer"
                  :to="{name:'team.event.participate',params :{id:item.shareKey}}"
                > ShareLink</router-link></span>
            </div>
          </div>
        </div>

        <h2 class="mb-2  flex flex-row primary-bg text-white p-2">
          <span class="flex-grow">Letzte Trainings</span>
          <router-link :to="{name:'training.sessions.create'}">
            <h3><i class="fas fa-calendar-plus"/></h3>
          </router-link>
        </h2>

        <div>
          <sc-sessions-small
            v-for="session in sessions"
            :key="session.id"
            :session-id="session.id"
            :session-title="session.title"
            :session-date="session.date"
            :team-id="session.teamId"
            :team-name="session.teamName"
            :emphasis-tags="session.tags.emphasized"
            :participated="session.playerReviews"
            :total-red="session.totalRed"
            :total-yellow="session.totalYellow"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiService from '../api/apiService'
import mailFormatter from '../mailFormatter'
import copy from 'copy-to-clipboard'
import playerCreateVue from '../players/player.create'

export default {
  name: 'TeamsDetailVue',
  data () {
    return {
      teamId: '-',
      team: null,
      newMemberName: '',
      newMemberYear: 2010,
      busy: false,
      sessions: [],
      inviteCodes: [],
      selectedMembers: [],
      nextEvents: [],
      playerCreationVisible: false,
      youths: [],
      selectedYouth: null
    }
  },
  inviteLink (code) {
    return '/teams/invitation/' + this.teamId + '/' + code
  },

  async mounted () {
    this.busy = true
    this.teamId = this.$route.params.id
    await this.loadTeam()
    this.selectedYouth = this.team.youth
    await this.loadSessions()
    this.youths = (await apiService.getYouths()).data
    var response = await apiService.getPubTeamEvents(this.teamId)
    this.nextEvents = response.data
    this.busy = false
  },
  computed: {
    currentTeam: function () {
      return this.teamId
    }
  },
  methods: {
    cancelPlayerCreation () {
      this.playerCreationVisible = false
    },
    async setYouth (youth) {
      if (!this.busy) {
        await apiService.setTeamYouth(this.teamId, this.selectedYouth)
      }
    },
    memberSelected (memberId) {
      if (memberId) {
        if (this.selectedMembers.includes(memberId)) {
          var index = this.selectedMembers.indexOf(memberId)
          if (index > -1) {
            this.selectedMembers.splice(index, 1)
          }
        } else {
          this.selectedMembers.push(memberId)
        }
      }
    },
    clipMails (mails) {
      mailFormatter.copyMails(mails)
    },
    clipAllMails () {
      const mails = this.team.members.map(x => x.eMailAdresses)
      mailFormatter.copyMails(mails)
    },
    clipAllMailsWithName () {
      var result = ''
      this.team.members.forEach(member => {
        var mails = member.eMailAdresses.map(x => x).flat().filter(x => !!x).join(';')
        result += member.name + ' ' + mails + '\n'
      })

      copy(result)
    },
    async getInviteCode () {
      var response = await apiService.createInviteCode(this.teamId)
      this.inviteCodes.push(response.data.code)
    },
    async loadSessions () {
      const response = await apiService.getSessionForTeam(this.teamId)

      this.sessions = response.data
    },
    async loadTeam () {
      const response = await apiService.getTeam(this.teamId)
      this.team = response.data
    },
    async addMember () {
      if (!this.busy) {
        this.playerCreationVisible = true
      }
    },
    async createMember (model) {
      this.playerCreationVisible = false

      await this.loadTeam()
    },

    async removeMember (memberId) {
      console.log('Removing member ... ' + memberId)

      console.log('Not implemented yet!')
    }
  }
}
</script>

<style scoped>

.member-multi-action-container {
  margin-top: 12px;

}

</style>
